import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import styles from "./styles";

function Logo() {
  return (
    <div className={styles.container}>
      <Link to="/#">
        <img src={logo} className={styles.fluidImage} alt="Uplus Logo" />
      </Link>
    </div>
  );
}

export default Logo;
